var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Gang({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "black",
    height: 48,
    viewBox: "0 0 64 48",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11.1917 2.6665c-1.27204 0-2.30303 1.04456-2.30303 2.33334v37.99996c0 1.2888 1.03099 2.3334 2.30303 2.3334h44.2828c1.2721 0 2.3031-1.0446 2.3031-2.3334v-37.99996c0-1.28878-1.031-2.33334-2.3031-2.33334zm45.0025 39.7787c0 .8541-.4058 1.2648-1.2474 1.2648h-43.2273c-.8424 0-1.2475-.4107-1.2475-1.2648v-36.89069c0-.85333.4051-1.26482 1.2475-1.26482h43.2273c.8416 0 1.2474.41149 1.2474 1.26482zm-18.6626-29.4624c0-.7879-.6418-1.4274-1.4326-1.4274-.7922 0-1.4325.6395-1.4325 1.4274v25.5896c0 .788.6403 1.4274 1.4325 1.4274.7908 0 1.4326-.6394 1.4326-1.4274zm7.1111 0c0-.7879-.6418-1.4274-1.4325-1.4274-.7923 0-1.4326.6395-1.4326 1.4274v25.5896c0 .788.6403 1.4274 1.4326 1.4274.7907 0 1.4325-.6394 1.4325-1.4274zm7.1112 0c0-.7879-.6418-1.4274-1.4326-1.4274-.7923 0-1.4326.6395-1.4326 1.4274v25.5896c0 .788.6403 1.4274 1.4326 1.4274.7908 0 1.4326-.6394 1.4326-1.4274zm-13.3487-6.72209c-.4231 0-.7665.36359-.7665.81159 0 .44881.3434.8116.7665.8116h9.4092c.4231 0 .7665-.36279.7665-.8116 0-.448-.3434-.81159-.7665-.81159z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Gang);
export default __webpack_public_path__ + "static/media/3Gang.cb39fa6bc4f80f84f01f0d0ad34bd2a0.svg";
export { ForwardRef as ReactComponent };